import { render, staticRenderFns } from "./AddContractComponent.vue?vue&type=template&id=59396ed8&"
import script from "./AddContractComponent.vue?vue&type=script&lang=js&"
export * from "./AddContractComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports